import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AppSettings} from '../../config/config';
import {map} from 'rxjs/operators';
import { apiConstants } from '../constant/apiConstant';

@Injectable()
export class AdmissionService {

  private URL = AppSettings.API_ENDPOINT;
  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  headers: HttpHeaders;
  private getAcademicListAPI = apiConstants.getAcademicListAPI;
  constructor(private http: HttpClient) {
  
  }


  getAllAcademicYears(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/academics/getacademicyearsfromnow',
      params, {headers}).pipe(map(res => res));

  }

  getAllCategories(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/classManagement/getcategories',
      params, {headers}).pipe(map(res => res));
  }

  getCategoryDetailsFromCategoryId(schoolId, categoryId, AUTHTOKEN) {
    const params = {schoolId, categoryId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/className',
      params, {headers}).pipe(map(res => res));
  }

  getClassDetailsFromClassId(classId, AUTHTOKEN) {
    const params = {classId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/classSectionName',
      params, {headers}).pipe(map(res => res));
  }


  getFeeComponentsOfClass(schoolId, academicId, classId, AUTHTOKEN) {
    const params = {schoolId, academicId, classId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/feeboard/classId',
      params, {headers}).pipe(map(res => res));
  }

  applyFeesAmountForTerm(schoolId, academicId, classId, feesTypeId, amount, AUTHTOKEN) {
    const params = {
      schoolId,
      academicId,
      classId,
      fkFeesTypeIdList: [{feeTypeId: feesTypeId, amount}]
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/feeboard/addNewFees',
      params, {headers}).pipe(map(res => res));
  }

  createFeesComponent(feesObj, AUTHTOKEN) {
    const params = feesObj;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/createNewfeeComponent',
      params, {headers}).pipe(map(res => res));
  }

  uploadImage(imageString, AUTHTOKEN) {

    const data = new FormData();
    const block = imageString.split(';');
    const contentType = block[0].split(':')[1];
    const realData = block[1].split(',')[1];
    const blob = this.b64toBlob(realData, contentType);
    data.append('image', blob);

    const headers = new HttpHeaders().append('authToken', AUTHTOKEN)
    return this.http.post(this.URL + '/upload/image/uploadandgetpath?userType=NEW_ADMISSION',
      data, {headers}).pipe(map(res => res));
  }

  createNewAdmission(admissionObj, AUTHTOKEN) {
    const params = admissionObj;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/addstudent/newAdmission',
      params, {headers}).pipe(map(res => res));
  }

  getStudentCategoriesFoAdmission(AUTHTOKEN) {
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/studentCategories/list/forAdmission',
      params, {headers}).pipe(map(res => res));
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, {type: contentType});
  }

  getAcademicList() {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token',localStorage.getItem('usertoken'));
    return this.http.get(this.URL_V3 + `${this.getAcademicListAPI}`,
    {headers}).pipe(map(res => res));
  }

  getPastCurrentAcademicList() {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    const params = new HttpParams().set('lang', 'en');
    return this.http.get(this.URL_V3 + `${apiConstants.getAcademicYearsAPI}`,
      { headers, params }).pipe(map(res => res));
  }

  getAdmissionEnquiryCategories(lang: string = 'en') {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token', localStorage.getItem('usertoken'));
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryCategoriesAPI}?lang=${lang}`,
      { headers }).pipe(map(res => res));
  }

  getAdmissionEnquiryClassStandards(categoryIds: (number | string)[], lang: string = 'en') {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token', localStorage.getItem('usertoken'));
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryClassStandardsAPI}?lang=${lang}&categoryId=${categoryIds.join(',')}`,
      { headers }).pipe(map(res => res));
  }

  getAdmissionEnquiryClassSections(categoryIds: (number | string)[], classStandardIds: (number | string)[], lang: string = 'en') {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token', localStorage.getItem('usertoken'));
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryClassSectionsAPI}?lang=${lang}&categoryId=${categoryIds.join(',')}&classStandardsId=${classStandardIds.join(',')}`,
      { headers }).pipe(map(res => res));
  }

  addAdmissionEnquiry(formData: FormData) {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    return this.http.post(this.URL_V3 + `${apiConstants.addAdmissionEnquiryAPI}`,
      formData, { headers }).pipe(map(res => res));
  }

  updateAdmissionEnquiry(formData: FormData) {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    return this.http.put(this.URL_V3 + `${apiConstants.updateAdmissionEnquiryAPI}`,
      formData, { headers }).pipe(map(res => res));
  }

  getAdmissionEnquiryList(options: {
    academicId: number | string;
    statusId?: number | string;
    categoryId?: number | string;
    classStandardsId?: number | string;
    classId?: number | string;
    search?: string;
    pageNumber: number;
    pageSize: number;
    lang?: string;
  }) {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    let params = new HttpParams()
      .set('lang', options.lang ?? 'en')
      .set('academicId', `${options.academicId}`)
      .set('statusId', `${options.statusId ?? ''}`)
      .set('categoryId', `${options.categoryId ?? ''}`)
      .set('classStandardsId', `${options.classStandardsId ?? ''}`)
      .set('classId', `${options.classId ?? ''}`)
      .set('search', options.search ?? '')
      .set('pageNumber', `${options.pageNumber}`)
      .set('pageSize', `${options.pageSize}`);
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryListAPI}`,
      { headers, params }).pipe(map(res => res));
  }

  getAdmissionEnquiryStatuses(lang: string = 'en') {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    const params = new HttpParams().set('lang', lang);
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryStatusesAPI}`,
      { headers, params }).pipe(map(res => res));
  }

  exportAdmissionEnquiryList(options: {
    academicId: number | string;
    statusId?: number | string;
    categoryId?: number | string;
    classStandardsId?: number | string;
    classId?: number | string;
    search?: string;
    lang?: string;
  }) {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    const params = new HttpParams()
      .set('lang', options.lang ?? 'en')
      .set('academicId', `${options.academicId}`)
      .set('statusId', `${options.statusId ?? ''}`)
      .set('categoryId', `${options.categoryId ?? ''}`)
      .set('classStandardsId', `${options.classStandardsId ?? ''}`)
      .set('classId', `${options.classId ?? ''}`)
      .set('search', options.search ?? '');
    return this.http.get(this.URL_V3 + `${apiConstants.exportAdmissionEnquiryAPI}`,
      { headers, params, responseType: 'blob' as 'json' }).pipe(map(res => res));
  }

  getLastRegId(AUTHTOKEN: string) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/addstudent/getLastRegId',
      {}, { headers }).pipe(map(res => res));
  }

  convertAdmissionEnquiry(formData: FormData) {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    return this.http.post(this.URL_V3 + `${apiConstants.convertAdmissionEnquiryAPI}`,
      formData, { headers }).pipe(map(res => res));
  }

  getAdmissionEnquiryDetail(academicId: number | string, enquiryId: number | string, lang: string = 'en') {
    const headers = new HttpHeaders().append('token', localStorage.getItem('usertoken'));
    const params = new HttpParams()
      .set('lang', lang)
      .set('academicId', `${academicId}`)
      .set('enquiryId', `${enquiryId}`);
    return this.http.get(this.URL_V3 + `${apiConstants.getAdmissionEnquiryDetailAPI}`,
      { headers, params }).pipe(map(res => res));
  }
}
